import { createInjectionKey as o } from "./ghl-ui.es896.js";
const e = o("n-modal-body"), d = o("n-modal-provider"), t = o("n-modal");
export {
  e as modalBodyInjectionKey,
  t as modalInjectionKey,
  d as modalProviderInjectionKey
};
